import { render, staticRenderFns } from "./TwoFactorMethodSetting.vue?vue&type=template&id=8dc019ae"
import script from "./TwoFactorMethodSetting.vue?vue&type=script&lang=ts"
export * from "./TwoFactorMethodSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports